import HamptonEast1 from '../../../Media/Ruko Paramount/Hampton East/Hampton East (1).webp'
import HamptonEast2 from '../../../Media/Ruko Paramount/Hampton East/Hampton East (2).webp'
import HamptonEast3 from '../../../Media/Ruko Paramount/Hampton East/Hampton East (3).webp'
import HamptonEast4 from '../../../Media/Ruko Paramount/Hampton East/Hampton East (4).webp'

const HamptonEastimages =[
HamptonEast1,HamptonEast2,HamptonEast3,HamptonEast4
]

export default HamptonEastimages;
